import { Requester } from './Requester';
import { ILoanRecord } from '../types';

export const GetOrganizationLoans = async ({
    orgId
}: {
    orgId: string;
}): Promise<{ loans: ILoanRecord[]; totalRecords: number } | null> => {
    try {
        const response = await Requester<{ loans: ILoanRecord[]; totalRecords: number }>({
            // port: '8080',
            path: `organizations/${orgId}/loans`,
            method: 'GET'
        });

        if ('loans' in response && Array.isArray(response.loans)) return response;
        return null;
    } catch (e) {
        console.error('Get org loans request failed');
        return Promise.reject(e);
    }
};
